module.exports = __webpack_public_path__ + "img/partner_10.0e38ea3e.png";